import { getThumbnail } from "../../utils";
import { getSmallerResolution } from "../../utils/products/getSmallerResolution";

export const productImageResizer = {
  methods: {
    getProductThumbnail(productUrl, store) {
      return getThumbnail(productUrl, store);
    },
    getProductImageLowRes(productUrl, store) {
      return getSmallerResolution(productUrl, store);
    }
  }
};
